import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-multiple-select',
  templateUrl: './bcac-multiple-select.component.html',
  styleUrls: ['./bcac-multiple-select.component.scss']
})
export class BcacMultipleSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  
  width = "9rem";
  @Input()
  set bcacWidth(value: string) {
    this.width = value;
  }

  dropMenuPanelWidth = "10rem";
  @Input()
  set bcacDropMenuPanelWidt(value: string) {
    this.dropMenuPanelWidth = value;
  }

  selectText = "";

  isexpand = false;
  expandChange(e) {
    this.isexpand = e;
  }
  selectValue = [];

  @Input()
  set bcacSelectValue(value: []) {
    this.selectValue = value;
    let text = "";
    this.selectValue.forEach(e=> {
      if(e.checked) {
        text = text + (e.label) + " ";
      }
    });
    this.selectText = text;
  }

  @Output()
  bcacSelectValueEmit = new EventEmitter<any>();
  updateSelectValue() {
    this.bcacSelectValueEmit.emit(this.selectValue);
    let text = "";
    this.selectValue.forEach(e=> {
      if(e.checked) {
        text = text + (e.label) + " ";
      }
    });
    this.selectText = text;
  }

  allChecked = false;
  indeterminate = true;
  updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.selectValue = this.selectValue.map(
        (item) => {
          return {
            ...item,
            checked: true,
          };
        }
      );
    } else {
      this.selectValue = this.selectValue.map(
        (item) => {
          return {
            ...item,
            checked: false,
          };
        }
      );
    }
    this.updateSelectValue();
  }

  updateSingleChecked(): void {
    if (this.selectValue.every((item) => !item.checked)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.selectValue.every((item) => item.checked)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
    this.updateSelectValue();
  }

}
